import CircularProgress from '@mui/material/CircularProgress';
import Rating from '@mui/material/Rating';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Header from "../../pages/home/homeHeader/Header/Header";
import "../../pages/thankyoupage/thankyoupage.css";
import SuccessIcon from "../Icons/sucessIcon"
export function ThankYouContent({ 
  rating, 
  setRating, 
  comment, 
  setComment, 
  handleSubmit, 
  isSubmitted,
  showHeader = false 
}) {
  const handleCommentChange = (e) => {
    const value = e.target.value;
    const words = value.trim().split(/\s+/).filter(Boolean);
    if (words.length <= 10) {
      setComment(value);
    }
  };

  return (
    <>
      {showHeader && <Header isInterviewMode={true} />}
      <div className="cardAfterQuestion">
        <div className="start_test_text_top after_endtest_submit">
          <div className="registered_img">
            
            <SuccessIcon className="successImagess"/>
          </div>
          <p className="fs-semi-bold fs-22 f-color mb_16 text-center">
            Thank you for using ClearedTalent.
          </p>
          <p className="fs-semi-bold fs-18 f-color mb_16 text-center">
            Your feedback is very important to us. Please visit us at
            <a
              className="ml_10"
              href="https://www.clearedtalent.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.clearedtalent.com
            </a>
          </p>
          <p className="fs-semi-bold fs-18 f-color text-center">
            Your test result is sent to the reviewer.
          </p>
        </div>

        {!isSubmitted ? (
          <div className="feedback-section">
            <p className="fs-semi-bold fs-16 f-color text-center mb_12">
              Please provide your rating and feedback for the test.
            </p>
            
            <div className="rating-container">
              <Rating
                name="test-rating"
                value={rating}
                onChange={(event, newValue) => setRating(newValue)}
                size="large"
              />
            </div>

            <div className="comment-container">
              <TextField
                label="Comment"
                multiline
                rows={4}
                value={comment}
                onChange={handleCommentChange}
                placeholder="Share your experience (max 10 words)..."
                fullWidth
                variant="outlined"
                helperText={`${comment.trim() ? comment.trim().split(/\s+/).filter(Boolean).length : 0}/10 words`}
              />
            </div>

            <div className="submit-button-container">
              <Button
                variant="contained"
                onClick={handleSubmit}
                className="submit-feedback-btn"
              >
                Submit
              </Button>
            </div>
          </div>
        ) : (
          <div className="containerfor_circul">
            <CircularProgress />
            <p className="fs-semi-bold fs-16 f-color text-center redirecting-text">
              Redirecting...
            </p>
          </div>
        )}
      </div>
    </>
  );
}